import { ScrollingModule } from "@angular/cdk/scrolling";
import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-table-skeleton",
  standalone: true,
  imports: [ ScrollingModule ],
  templateUrl: "./table-skeleton.component.html",
  styleUrl: "./table-skeleton.component.scss"
})
export class TableSkeletonComponent {
  public columnHeight: number = 60;

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  public columns: number[] = Array.from({ length: 1000 }, (_: undefined, i: number) => i + 1);
}
